import { render, staticRenderFns } from "./StatusTag.vue?vue&type=template&id=206510f9&"
import script from "./StatusTag.vue?vue&type=script&lang=js&"
export * from "./StatusTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports